export default "__VITE_ASSET__Bzir86RO__"